<template>
    <div class="row justify-center q-my-xl">
        <q-card style="width: 100%; max-width: 375px;">
            <q-card-section class="bg-primary">
                <div class="text-center">
                    <img :src="require('@/assets/img/logos/avenir-white.png')" height="30" class="q-my-md" />
                    <q-separator dark />
                </div>
                <div class="text-white text-center text-caption q-mt-md">
                    {{ instructionText }}
                </div>
            </q-card-section>

            <q-card-section class="bg-white " :class="{'q-px-md q-py-lg': screenSize.xs, 'q-px-lg q-py-xl': !screenSize.xs}">
                <q-form @submit="onSubmit"
                        @reset="onReset"
                        autocomplete="off"
                        class="q-col-gutter-md">
                    <q-banner v-if="(authStatus == 'error')" rounded class="text-white bg-negative">
                        <q-icon name="mdi-alert" size="sm" color="white" class="q-mr-xs" />
                        <div v-html="errorMessage" style="margin-top: -20px; margin-left: 30px;"></div>
                    </q-banner>
                    <q-input outlined dense
                             @input="authStatus = ''"
                             label="Email" stack-label
                             autocomplete="on" name="email"
                             v-model.trim="form.username"
                             :rules="[ val => $v.form.username.required || 'Email is required', val => $v.form.username.email || 'Not a valid email format'  ]"
                             hide-bottom-space>
                    </q-input>
                    <q-input outlined dense
                             @input="authStatus = ''"
                             label="Password" stack-label
                             autocomplete="current-password" name="password"
                             v-model="form.password"
                             :type="isPwd ? 'password' : 'text'"
                             :rules="[ val => $v.form.password.required || 'Password is required' ]"
                             hide-bottom-space>
                        <template v-slot:append>
                            <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                                    class="cursor-pointer"
                                    color="grey-6" size="0.9em"
                                    @click="isPwd = !isPwd" />
                        </template>
                    </q-input>

                    <div class="row text-center q-col-gutter-sm justify-center">
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn :label="(authStatus == 'loading') ? 'Signing In...' : 'Sign In'" type="submit" color="primary" class="full-width" />
                        </div>
                        <div v-if="!autoActivationMode" class="col-xs-12 col-sm-auto">
                            <q-btn label="Cancel" @click="onCancel" color="primary" flat class="full-width" />
                        </div>
                    </div>
                </q-form>
            </q-card-section>
            <q-separator />
            <q-card-actions class="text-caption bg-grey-1" :class="{'q-py-sm q-px-md': screenSize.xs, 'q-py-md q-px-lg': !screenSize.xs}">

                <div v-if="autoActivationMode" class="col-6 items-start">
                    <q-btn @click.prevent="$emit('forgot');" label="Forgot Password?" no-caps class="text-primary text-caption" flat />
                </div>

                <div v-if="!autoActivationMode" class="col-6 items-start">
                    <q-btn @click.prevent="$emit('close', 'ForgotPassword'); $router.push({ name: '/forgotpass', params:{ returnUrl: currentReturnUrl }}).catch(err => {});" label="Forgot Password?" no-caps class="text-primary text-caption" flat />
                </div>
                <div v-if="!autoActivationMode" class="col-6 items-end text-right ">
                    <q-btn @click.prevent="$emit('close', 'CreateNewAccount'); $router.push({ name: '/newaccount', params:{ returnUrl: currentReturnUrl }}).catch(err => {});" label="Create New Account" no-caps class="text-primary text-caption" flat />
                </div>
            </q-card-actions>
            <q-inner-loading :showing="(authStatus == 'loading')">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </q-card>
    </div>
</template>
<script>
    import { required, email } from 'vuelidate/lib/validators'
    import { avoidIfLoggedIn } from '@/plugins/urlPaths'

    export default {
        name: 'login-page',
        props: {
            returnUrl: {
                default: '',
                type: String
            },
            autoActivationMode: {
                default: false,
                type: Boolean
            },
        },
        data() {
            return {
                currentReturnUrl: '',
                isPwd: true,
                errorMessage: 'Invalid credentials',
                form: {
                    username: '',
                    password: '',
                },
            }
        },
        validations: {
            form: {
                username: { required, email },
                password: { required },
            }
        },
        methods: {
            login() {
                try {
                    this.$store.dispatch('login', this.form).then(() => {
                        if (this.autoActivationMode) {
                            this.$emit('loggedIn')
                            return
                        }

                        if (this.user && this.user.emailConfirmed == 'False') {
                            this.$router.push('/account/confirm').catch(err => { })
                            return
                        }

                        if (this.user && this.user.emailConfirmed == 'True') {
                            if (this.currentReturnUrl && !this.currentReturnUrl.includes('/account/confirm') && !avoidIfLoggedIn.includes(this.currentReturnUrl)) this.$router.push(this.currentReturnUrl).catch(err => { })
                            else this.$router.push('/').catch(err => { })
                            return
                        }

                        else this.$router.push('/').catch(err => { })
                    }).catch(err => {
                        if (err.response) {
                            this.errorMessage = err.response.data.error_description
                        }
                    })
                } catch (err) {
                    this.addCustomErrorContext(err, "Method: login")
                    throw err;
                }
            },
            onSubmit() {
                try {
                    this.$v.form.$touch()
                    if (this.$v.form.$pending || this.$v.form.$error) return
                    this.login()
                } catch (err) {
                    this.addCustomErrorContext(err, "Method: onSubmit")
                    throw err;
                }
            },
            onCancel() {
                if (this.$listeners.close) {
                    this.$emit('close');
                } else {
                    this.$router.push('/');
                }
            },
            onReset() {
                this.form = {
                    username: '',
                    password: '',
                }
                this.authStatus = ''
            },
            addCustomErrorContext(err, location) {
                if (typeof err !== 'object' || err === null) return;

                const contextKey = "\\src\\components\\Login.Vue";

                if (!err._customContext) {
                    err._customContext = {};
                }

                if (!err._customContext[contextKey]) {
                    err._customContext[contextKey] = {
                        errorThrownCallStack: [],
                        props: {
                            autoActivationMode: this.autoActivationMode,
                            returnUrl: this.returnUrl,
                        },
                        data: {
                            formUsernameContents: this.form.username,
                            currentReturnUrl: this.currentReturnUrl,
                        },
                    };
                }

                // Add the location to the array if it's not already present
                const locations = err._customContext[contextKey].errorThrownCallStack;
                if (!locations.includes(location)) {
                    locations.push(location);
                }

                return;
            },
        },
        computed: {
            instructionText() {
                if (this.autoActivationMode) return 'Sign in to continue'
                return 'Sign in or create a new account to continue'

            },
            user() { return this.$store.getters.authUser },
            authStatus: {
                get() {
                    return this.$store.getters.authStatus
                },
                set(value) {
                    this.$store.commit('auth_clear')
                }
            },
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            try {
                this.onReset()
                this.currentReturnUrl = this.returnUrl || this.$route.fullPath
            } catch (err) {
                this.addCustomErrorContext(err, "Hook: created")
                throw err;
            }
        },
        errorCaptured(err, vm, info) {
            this.addCustomErrorContext(err, "Hook: errorCaptured (Comes from Child Component)");
            return;
        },
    }
</script>
